(function () {
  'use strict';

  // ── Banner dismiss ────────────────────────────────────────────────────────
  function initBanner() {
    document.querySelectorAll('.bn-banner[data-dismissible="true"]').forEach(function (banner) {
      var key = 'bn-dismissed-' + banner.id;
      if (localStorage.getItem(key)) { banner.style.display = 'none'; return; }
      var btn = banner.querySelector('.bn-banner__close');
      if (!btn) return;
      btn.addEventListener('click', function () {
        banner.style.transition = 'height 0.25s ease, opacity 0.25s ease';
        banner.style.overflow = 'hidden';
        banner.style.height = banner.offsetHeight + 'px';
        requestAnimationFrame(function () {
          banner.style.opacity = '0';
          banner.style.height = '0';
        });
        setTimeout(function () { banner.style.display = 'none'; }, 260);
        localStorage.setItem(key, '1');
      });
    });
  }

  // ── Sticky header ─────────────────────────────────────────────────────────
  function initStickyHeader() {
    var header = document.getElementById('bn-header');
    if (!header || header.dataset.sticky !== 'true') return;
    var ticking = false;
    function tick() {
      header.classList.toggle('bn-scrolled', window.scrollY > 10);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(tick); ticking = true; }
    }, { passive: true });
    tick();
  }

  // ── Cart side drawer ──────────────────────────────────────────────────────
  function initCartDrawer() {
    document.querySelectorAll('[data-bn-cart-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {

        // FoxTheme: <cart-drawer id="CartDrawer" hidden> — opened by removing hidden attribute.
        // The custom element observes the attribute and runs its open animation automatically.
        var drawer = document.getElementById('CartDrawer');
        if (drawer) {
          e.preventDefault();
          if (typeof drawer.open === 'function') { drawer.open(); return; }
          if (typeof drawer.show === 'function') { drawer.show(); return; }
          drawer.removeAttribute('hidden');
          return;
        }

        // Generic fallback: try other common theme cart trigger patterns
        var trigger = document.querySelector(
          '[data-cart-toggle]:not([data-bn-cart-trigger]),' +
          '[data-open-cart]:not([data-bn-cart-trigger]),' +
          '[aria-controls="cart-drawer"]:not([data-bn-cart-trigger]):not(.fixed-overlay):not(.drawer__close-btn),' +
          '[data-js="cart-toggle"]:not([data-bn-cart-trigger])'
        );
        if (trigger) { e.preventDefault(); trigger.click(); return; }

        // Last resort: navigate to /cart naturally (no preventDefault)
      });
    });
  }

  // ── Live cart count ───────────────────────────────────────────────────────
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = count;
          el.style.display = count > 0 ? 'flex' : 'none';
        });
        document.querySelectorAll('.bn-cart-info__count').forEach(function (el) {
          el.textContent = count + (count === 1 ? ' item' : ' items');
        });
        document.querySelectorAll('[data-bn-cart-trigger]').forEach(function (btn) {
          btn.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
        });
      })
      .catch(function () {});
  }

  // ── Mega menu ─────────────────────────────────────────────────────────────
  // CSS :hover on .bn-nav-item--mega drives show/hide.
  // JS only handles touch (first tap = open, second tap = navigate).
  function initMegaMenu() {
    document.querySelectorAll('#bn-header .bn-nav-item--mega').forEach(function (item) {
      var link = item.querySelector('.bn-nav-link');
      if (!link) return;
      link.addEventListener('click', function (e) {
        if ('ontouchstart' in window && !item.classList.contains('bn-mega-open')) {
          e.preventDefault();
          document.querySelectorAll('#bn-header .bn-nav-item--mega').forEach(function (i) {
            i.classList.remove('bn-mega-open');
          });
          item.classList.add('bn-mega-open');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('#bn-header .bn-nav-item--mega')) {
        document.querySelectorAll('#bn-header .bn-nav-item--mega').forEach(function (i) {
          i.classList.remove('bn-mega-open');
        });
      }
    });
  }

  // ── Mobile drawer ─────────────────────────────────────────────────────────
  function initMobileDrawer() {
    var drawer    = document.getElementById('bn-mobile-drawer');
    var hamburger = document.getElementById('bn-hamburger');
    var closeBtn  = document.getElementById('bn-mobile-close');
    var overlay   = document.getElementById('bn-drawer-overlay');
    var header    = document.getElementById('bn-header');
    if (!drawer || !hamburger) return;

    function openDrawer() {
      drawer.classList.add('bn-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      if (header) header.classList.add('bn-mobile-open');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('button, a, input');
      if (first) setTimeout(function () { first.focus(); }, 280);
    }

    function closeDrawer() {
      drawer.classList.remove('bn-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      if (header) header.classList.remove('bn-mobile-open');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('bn-drawer-open')) closeDrawer();
    });

    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        if (drawer.classList.contains('bn-drawer-open')) closeDrawer();
      });
    });
  }

  // ── Mobile accordion ──────────────────────────────────────────────────────
  function initMobileAccordion() {
    document.querySelectorAll('.bn-mobile-accord').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var isOpen = btn.classList.contains('bn-accord-open');

        document.querySelectorAll('.bn-mobile-accord.bn-accord-open').forEach(function (other) {
          if (other !== btn) {
            other.classList.remove('bn-accord-open');
            other.setAttribute('aria-expanded', 'false');
            var ob = other.nextElementSibling;
            if (ob) ob.classList.remove('bn-accord-open');
          }
        });

        btn.classList.toggle('bn-accord-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (body) body.classList.toggle('bn-accord-open', !isOpen);
      });
    });
  }

  // ── Listen for cart updates from other theme scripts ──────────────────────
  document.addEventListener('cart:updated', refreshCartCount);
  document.addEventListener('theme:cart:update', refreshCartCount);

  // ── Boot ──────────────────────────────────────────────────────────────────
  function init() {
    initBanner();
    initStickyHeader();
    initCartDrawer();
    refreshCartCount();
    initMegaMenu();
    initMobileDrawer();
    initMobileAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
